import React from 'react'

const SingleWindow = () => {
  return (
    <div>SingleWindow</div>
  )
}

export default SingleWindow